
import { useLanguage } from '@/contexts/LanguageContext';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  type?: 'school' | 'breed' | 'guide' | 'logo';
  location?: string;
}

export const OptimizedImage = ({
  src,
  alt,
  className,
  width,
  height,
  type = 'school',
  location
}: OptimizedImageProps) => {
  const { language } = useLanguage();

  // Generiere SEO-optimierte Alt-Texte
  const getOptimizedAltText = () => {
    const baseAlt = alt.trim();
    if (!baseAlt) return '';

    const locationSuffix = location ? (language === 'de' ? ` in ${location}` : ` in ${location}`) : '';
    
    switch (type) {
      case 'school':
        return language === 'de'
          ? `Hundeschule ${baseAlt}${locationSuffix} - Professionelles Hundetraining und Welpenerziehung`
          : `Dog school ${baseAlt}${locationSuffix} - Professional dog training and puppy education`;
      case 'breed':
        return language === 'de'
          ? `${baseAlt} - Rassetypische Eigenschaften und Trainingstipps für diese Hunderasse`
          : `${baseAlt} - Breed characteristics and training tips for this dog breed`;
      case 'guide':
        return language === 'de'
          ? `${baseAlt} - Expertentipps und Anleitungen für Hundehalter`
          : `${baseAlt} - Expert tips and guides for dog owners`;
      case 'logo':
        return language === 'de'
          ? `${baseAlt} - Ihr vertrauenswürdiger Partner für Hundeschulen${locationSuffix}`
          : `${baseAlt} - Your trusted partner for dog schools${locationSuffix}`;
      default:
        return baseAlt;
    }
  };

  return (
    <img
      src={src}
      alt={getOptimizedAltText()}
      className={className}
      width={width}
      height={height}
      loading="lazy"
    />
  );
};
